import styled from 'styled-components'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { FormLabel, Select } from '@material-ui/core'

export const StyledFormLabel = styled(FormLabel)`
    // color: ${({ theme }) => theme.colors.gray[700]};

  &.MuiFormLabel-root.Mui-focused {
    color: ${({ theme }) => theme.colors.gray[900]};
  }
`

export const StyledFormControlLabel = styled(FormControlLabel)`
  .MuiIconButton-label {
    color: ${({ theme }) => theme.colors.nightshade.medium};
  }
`
export const StyledSelect = styled(Select)`
  color: ${({ theme }) => theme.colors.gray[900]};
  font-size: 1rem;
  margin-top: 1rem;
  width: 100%;
  max-width: 250px;
  min-width: 250px;
  white-space: normal;

  .MuiSelect-select {
    white-space: normal;
    overflow-wrap: break-word;
    word-wrap: break-word;
    line-height: 1.4;
    min-height: 1.5em;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .MuiMenuItem-root {
    white-space: normal;
    overflow-wrap: break-word;
    word-wrap: break-word;
    line-height: 1.4;
    min-height: auto;
    padding: 8px 16px;
  }
`
